module.exports = __webpack_public_path__ + "static/media/10.056e2df8.jpg";